import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import classNames from 'classnames';
import QRCode from 'qrcode';

import { Typography } from '@canvas-logic/clp-shared-ui';

import ThemeDefinition from '../../domain/ThemeDefinition';

import style from './QrCodeDialog.module.css';

interface IProps {
  className?: string;
  link: string;
}

export const QrCodeDialog: React.FC<IProps> = ({ link, className }) => {
  const { t: tTranslation } = useTranslation('translation');
  const canvasRef = React.createRef<HTMLCanvasElement>();

  React.useEffect(() => {
    if (canvasRef.current && link) {
      QRCode.toCanvas(canvasRef.current, link);
    }
  }, [link]);

  return (
    <div className={classNames(style.root, ThemeDefinition.qrCodeDialog.root, className)}>
      <canvas className={style.canvas} ref={canvasRef} />
      <div className={style.text}>
        <Typography variant="paragraph-md" color="description">
          <Trans
            i18nKey="configuratorPage.qrCode.qrCodeDescription"
            ns="translation"
            components={{
              lnk: (
                <a data-ar-link href={link}>
                  {tTranslation('configuratorPage.qrCode.clickHere')}
                </a>
              ),
            }}
          />
        </Typography>
      </div>
    </div>
  );
};
